const apis = () => {
  const base = (process.env.REACT_APP_API_URL || 'http://localhost:5050').replace(/\/$/, '');
  const local = `${base}/`;

  return {
    localUrl: local,
    health: `${base}/health`,
    authLogin: `${base}/auth/login`,
    authMe: `${base}/auth/me`,
    authRefresh: `${base}/auth/refresh`,
    authLogout: `${base}/auth/logout`,
    changePassword: `${base}/auth/change-password`,
    adminUsersList: `${base}/admin-users/list`,
    adminUsersAdd: `${base}/admin-users/add`,
    adminUsersUpdate: `${base}/admin-users/update`,
    adminUsersDelete: `${base}/admin-users/delete`,
    getUserList: `${base}/user/list`,
    addUser: `${base}/user/add`,
    uploadFile: `${base}/file/upload`,
    updateUser: `${base}/user/update`,
    deleteUser: `${base}/user/delete`,
    addBranch: `${base}/branch/add`,
    branchList: `${base}/branch/list`,
    updateBranch: `${base}/branch/update`,
    deleteBranch: `${base}/branch/delete`,
    addAmmenity: `${base}/ammenity/add`,
    ammenityList: `${base}/ammenity/list`,
    updateAmmenity: `${base}/ammenity/update`,
    addProperty: `${base}/property/add`,
    propertyList: `${base}/property/list`,
    singleProperty: `${base}/property/single`,
    editProperty: `${base}/property/edit`,
    deleteListing: `${base}/property/delete`,
    listingMarkHot: `${base}/property/markhot`,
    getHotListing: `${base}/property/hot`,
    getListingDetail: `${base}/property/detail`,
    getListingSimilar: `${base}/property/list/similar`,
    lisitingAddVisit: `${base}/property/add/visit`,
    lisitingAddClick: `${base}/property/add/click`,
    listingProjectList: `${base}/property/project/list`,
    getProjectDetail: `${base}/property/project/detail`,
    getTopLocations: `${base}/property/location/top`,
    addLocation: `${base}/property/location/add`,
    getLocationList: `${base}/property/location/list`,
    updatelocation: `${base}/property/location/update`,
    deletelocation: `${base}/property/location/delete`,
    getListingList: `${base}/property/listing/list`,
    getProjectListingListAll: `${base}/property/listing/project/list/all`,
    publicSettings: `${base}/settings/public`,
    updateSettings: `${base}/settings/update`,
    blogList: `${base}/blog/list`,
    blogDetail: `${base}/blog/detail`,
    blogAdd: `${base}/blog/add`,
    contactSubmit: `${base}/contact/submit`,
    contactList: `${base}/contact/list`,
    contactUpdate: `${base}/contact/update`,
    contactDelete: `${base}/contact/delete`,
    reviewList: `${base}/review/list`,
    reviewAdd: `${base}/review/add`,
    reviewUpdate: `${base}/review/update`,
    reviewDelete: `${base}/review/delete`,
  };
};

export default apis;
